export var OrderValidationResponse;
(function (OrderValidationResponse) {
    OrderValidationResponse.OrderValidityEnum = {
        IsValid: 'IsValid',
        DoesNotMeetMinimumSpend: 'DoesNotMeetMinimumSpend',
        PastLiquorCurfew: 'PastLiquorCurfew',
        CampaignRedemptionFailed: 'CampaignRedemptionFailed',
        ExpressOrderExceedsMaxItemCount: 'ExpressOrderExceedsMaxItemCount',
        ExpressIsClosed: 'ExpressIsClosed',
        ExpressDeliveryLiquorRestriction: 'ExpressDeliveryLiquorRestriction',
        FlexibleDeliveryLiquorRestriction: 'FlexibleDeliveryLiquorRestriction'
    };
})(OrderValidationResponse || (OrderValidationResponse = {}));
